const cf = {
  timeCompare(target1, target2 = Date.now()) {
    return target1 < target2 ? 'earlier' : 'later';
  },
  getScriptPromise(scriptUrl) {
    return new Promise((resolve) => $.getScript(scriptUrl, resolve));
  },
  arrayClone(targetArr) {
    const resultArr = [];
    const obj = $.extend(true, {}, targetArr);
    for (const index in obj) {
      resultArr[index] = obj[index];
    }

    return resultArr;
  },
  getDateStr() {
    const date = new Date();
    const yearStr = date.getFullYear().toString();
    const month = date.getMonth() + 1;
    const monthStr = month >= 10 ? month : '0' + month;
    const dateStr = date.getDate() >= 10 ? date.getDate().toString() : '0' + date.getDate();

    return `${yearStr}-${monthStr}-${dateStr}`;
  },
  type(obj) {
    return Object.prototype.toString.call(obj).slice(8, -1);
  },

  /* 两个数组中只要有一个子元素相同就返回true，否则返回false */
  checkArrayRepeat(arr1, arr2) {
    for (const i in arr2) {
      if ($.inArray(arr2[i], arr1) > -1) {
        return true;
      }
    }

    return false;
  },
};

export default cf;



// WEBPACK FOOTER //
// ./src/libs/common.function.js